import { useRouter } from "next/router";

import Listing from "@components/wishlist/list";
import styles from "@styles/listing.module.scss";
import SeoMeta from "@components/common/seo";
function WishList() {
  const router = useRouter();
  const { ...filters } = router.query;
  let wishlist = router.pathname;
  return (
    <div className={styles.listingPageBlock}>
      <SeoMeta
        title={`Wishlist | It's Shopping - but Better!`}
        url={router.asPath}
        description={`Save your favorite brands and shop at your convenience when the time in right for you to buy.`}
        keywords={`Shopping wishlist`}
      />
      <Listing styles={styles} filters={filters} wishlist={wishlist} />
    </div>
  );
}

WishList.Layout = true;
// WishList.requireAuth = true;
export default WishList;
